
import React from 'react'
import classNames from 'classnames'
import request from 'superagent'
import Helpers from '../../../../../_plugins/lib/helpers'
import ReduxStores from '../../../../stores/connects'
import { func, string, object, bool } from 'prop-types'
import WelcomeBackMsg from '../welcomeBackMsg'

class LoggedInUser extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.logout = this.logout.bind(this)
  }

  handleClick (e) {
    const { handleClick, classCheck, active } = this.props
    e.preventDefault()
    if (classCheck === active) handleClick()
    else handleClick(classCheck)
  }

  logout () {
    const loggedInLi = this._loggedInLi
    loggedInLi.className += ' hide'
    request
      .get('https://v2.holidayextras.co.uk/tripapp-rails/users/sign_out.json?_method=delete')
      .withCredentials()
      .end(() => {
        const aTag = Helpers.$('a', loggedInLi)
        aTag.click()
        this.props.handleClick('', true)
        this.props.userLogoutResponse()
      })
  }

  handleClickOutside () {
    this.props.handleClick()
  }

  render () {
    const { classCheck, active, loggedIn = {}, showWelcomeBackMsg, welcomeBackMsgVisible, closeWelcomeBackMsg } = this.props
    if (!loggedIn.email || !loggedIn.first_name) return null
    const activeClass = classNames({
      'dropdown': true,
      'userlogin': true,
      'largescreen': true,
      'visible-loggedin': true,
      'open': active === classCheck
    })
    let extendUsernameLg = ''
    if (loggedIn.email.length > 34) extendUsernameLg = '...'
    const username = loggedIn.email.substr(0, 34) + extendUsernameLg

    return (
      <li ref={(c) => (this._loggedInLi = c)} className={activeClass}>
        <a href='#' data-toggle='dropdown' onClick={this.handleClick} title='Holiday extras' className='ignore-react-onclickoutside single' data-hxtrack-name={'header_dropdown_your_account'} data-hxtrack-value={classCheck === active ? 'closed' : 'opened'}>Hello {loggedIn.first_name}, Your Account<span className='caret' /></a>
        { showWelcomeBackMsg && (
          <WelcomeBackMsg welcomeBackMsgVisible={welcomeBackMsgVisible} isOnMobile={false} loggedInData={loggedIn} closeWelcomeBackMsg={closeWelcomeBackMsg} />
        )}
        <ul className='dropdown-menu'>
          <li className='dropdown-header' role='presentation'>
            <div className='h4'>
              { loggedIn.first_name } { loggedIn.last_name }
              <div className='small'>
                { username }
              </div>
            </div>
          </li>
          <li className='divider' />
          <li><a className='ignore-react-onclickoutside' href='https://v2.holidayextras.co.uk/static/#/mytrips' title='Trips &amp; Bookings'>Trips &amp; Bookings</a></li>
          <li><a className='ignore-react-onclickoutside' href='https://v2.holidayextras.co.uk/static/?#/users/edit?lang=en' title='Personal details'>Personal details</a></li>
          <li><a href='#' onClick={this.logout} className='ignore-react-onclickoutside userlogin-logout'>Logout</a></li>
        </ul>
      </li>
    )
  }
}

LoggedInUser.propTypes = {
  handleClick: func.isRequired,
  classCheck: string,
  active: string,
  loggedIn: object,
  showWelcomeBackMsg: bool,
  welcomeBackMsgVisible: bool,
  closeWelcomeBackMsg: func
}
LoggedInUser.defaultProps = {
  classCheck: 'loggedinuser',
  loggedIn: { },
  showWelcomeBackMsg: false,
  welcomeBackMsgVisible: false
}

export default ReduxStores(LoggedInUser, ['login'], true)
